let origin = "https://future.zhuneng.cn";
//创业导师列表
const getTeacherListUrl = `/gateway/hc-business/miniapi/advisor/getList`;

// 服务人数加一
const addCountURL = `/gateway/hc-business/miniapi/advisor/addServeCount`;

export { getTeacherListUrl, addCountURL };
